import { InvoiceModel } from "../../../types/Financial/InvoiceModel";
import { StripeConnectClientConfigModel, StripeConnectPaymentIntentModel } from "../../../types/Financial/StripeConnect";
import { APIRequest, APIRequestMethod } from "../APIRequest";
import { Client } from "../Client";

class PaymentAPI {
  GetInvoice(invoiceId: string): Promise<InvoiceModel> {
    return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/payment/invoices/${invoiceId}`));
  }
  
  GetInvoiceHTML(invoiceId: string): Promise<Blob> {
    return Client.RawRequest(new APIRequest(APIRequestMethod.GET, `/api/payment/invoices/${invoiceId}/export/html`))
      .then((res) => res.blob());
  }

  GetInvoicePDF(invoiceId: string): Promise<Blob> {
    return Client.RawRequest(new APIRequest(APIRequestMethod.GET, `/api/payment/invoices/${invoiceId}/export/pdf`))
      .then((res) => res.blob());
  }

  GetStripeConnectConfig(): Promise<StripeConnectClientConfigModel> {
    return Client.Request(new APIRequest(APIRequestMethod.GET, '/api/payment/stripe_connect/client_config'));
  }

  GetStripeConnectPaymentIntent(invoice: InvoiceModel): Promise<StripeConnectPaymentIntentModel> {
    return Client.Request(new APIRequest(APIRequestMethod.POST, `/api/payment/stripe_connect/create_payment_request/${invoice.InvoiceId}`));
  }
}

export { PaymentAPI }